import buttonSideModal from './buttonSideModal.vue'
export default buttonSideModal
